import { fontFamilies, mesaColorNames } from '@/src/common/theme'
import { Text } from 'react-native'

export const CardBenefitsComponentsTitle = ({ title }: { title: string }) => (
  <Text
    style={{
      color: mesaColorNames['Greyscale/900 #152438'],
      marginBottom: 16,
      fontFamily: fontFamilies['PlusJakartaSans-Bold'],
      fontWeight: 700,
      fontSize: 18,
    }}
  >
    {title}
  </Text>
)
